import { Utils } from '@/utils/Utils';
import { Achievements, IAchievement } from '../defaultObjects';
import store from '@/store';
import { ActionContext } from 'vuex';
import { ACTION } from '@/store/ACTION';

type State = {
  achievement: {
    data: IAchievement;
  };
};

export default {
  state: {
    achievement: {
      data: Achievements
    }
  },
  getters: {
    getProgressData(state: State, getters: any) {
      if (!getters.hasAchievement) return {};

      return state.achievement.data.progress;
    },
    getAchievement(state: State) {
      return state.achievement.data;
    },
    hasAchievement(state: State) {
      return Boolean(
        state.achievement.data && state.achievement?.data?.time?.startedTime && state.achievement?.data?.time?.stage
      );
    },
    isAchievementCounter(state: State, getters: any) {
      if (!state.achievement.data.rewardsTotal) return false;
      return getters.hasAchievement && state.achievement.data.rewardsTotal >= 0;
    },
    isAchievementBG(state: State, getters: any) {
      return getters.hasAchievement && state.achievement.data.reward.isAchievementBG;
    },
    isAchievementFS(state: State, getters: any) {
      return getters.hasAchievement && state.achievement.data.reward.isAchievementsFSandFR;
    },
    isAchievementPrizeGame(state: State, getters: any) {
      return getters.isAchievementFS || getters.isAchievementBG;
    },
    currentAchievementCounter(state: State, getters: any) {
      if (!getters.isAchievementCounter) return 0;

      return state.achievement.data.rewardsLeft;
    },
    totalFreeSpinsAchievementCounter(state: State, getters: any) {
      if (!getters.isAchievementCounter || !state.achievement.data.rewardsTotal) return 0;

      return state.achievement.data.rewardsTotal;
    },
    totalParticipantsAchievementCounter(state: State, getters: any) {
      if (!getters.isAchievementCounter || !state.achievement.data.rewardsTotal) return 0;

      return state.achievement.data.rewardsTotal / state.achievement.data.reward.rounds;
    },

    isProgressAchievementCounter(state: State, getters: any) {
      return getters.isAchievementCounter && state.achievement.data.reward.roundsLeft === null;
    },
    getAchievementWelcomePopup(state: State, getters: any) {
      return getters.getIsShowingWelcomePopup && getters.hasAchievement;
    },
    getAchievementStartData(state: State, getters: any) {
      if (!getters.hasAchievement) return '';

      return Utils.formatDate(new Date(state.achievement.data.time.startedAt));
    },
    getAchievementFinishData(state: State, getters: any) {
      if (!getters.hasAchievement) return '';

      return Utils.formatDate(new Date(state.achievement.data.time.finishedTime));
    },
    getNameGameAchievement(state: State, getters: any) {
      if (!getters.hasAchievement) return '';

      return state.achievement.data.reward.gameName;
    },
    getGameId(state: State, getters: any) {
      switch (true) {
        case getters.hasAchievement:
          return state.achievement.data.reward.gid;
        case getters.hasFreeSpinsTournament:
          return getters.getRewardTournament.gid;
        default:
          return null;
      }
    },
    getReward(state: State) {
      if (!state.achievement.data.reward) return {};

      return state.achievement.data.reward;
    },
    getAmountLeftSpinsAchievement(state: State, getters: any) {
      if (!getters.hasAchievement) return null;

      return state.achievement.data.reward.roundsLeft;
    },
    getAchievementCurrency(state: State, getters: any) {
      if (!getters.hasAchievement) return '';

      return state.achievement.data.currencyCode;
    },
    getAchievementMinBet(state: State, getters: any) {
      if (!getters.hasAchievement) return '';

      const cents = state.achievement.data.minBet;
      const currencyDecimals = state.achievement.data.currencyDecimals;
      const currencyCode = state.achievement.data.currencyCode;

      return Utils.centsToMoneyStr(cents, currencyDecimals, currencyCode);
    },
    getAchievementTotalRounds(state: State, getters: any) {
      if (!getters.hasAchievement && !getters.hasRoundsCondition) return '';

      return state.achievement.data.progress?.rounds?.total;
    },
    getAchievementTotalBets(state: State, getters: any) {
      if (!getters.hasAchievement && !getters.hasBetsCondition) return '';

      //@ts-ignore
      return state.achievement.data.progress.bets.total;
    },
    getAchievementTotalWins(state: State, getters: any) {
      if (!getters.hasAchievement && !getters.hasWinsCondition) return '';

      //@ts-ignore
      return state.achievement.data.progress.wins.total;
    },
    hasRoundsCondition(state: State, getters: any) {
      if (!getters.hasAchievement) return false;

      return Boolean(
        state.achievement.data.progress?.rounds?.total || state.achievement.data.progress?.rounds?.total === 0
      );
    },
    hasBetsCondition(state: State, getters: any) {
      if (!getters.hasAchievement) return false;

      return Boolean(
        state.achievement.data.progress?.bets?.total || state.achievement.data.progress?.bets?.total === 0
      );
    },
    hasWinsCondition(state: State, getters: any) {
      if (!getters.hasAchievement) return false;

      return Boolean(
        state.achievement.data.progress?.wins?.total || state.achievement.data.progress?.wins?.total === 0
      );
    },
    getAchievementShowingIcon(state: State, getters: any) {
      return getters.getIsShowingIcon && getters.hasAchievement;
    },

    getAchievementClosedTime(state: State, getters: any): string {
      if (!getters.hasAchievement) return '';

      return state.achievement.data.time.closedAt;
    },
    getAchievementFinishedTime(state: State, getters: any): string {
      if (!getters.hasAchievement) return '';

      return state.achievement.data.time.finishedAt;
    },
    getLinkGame(state: State, getters: any) {
      if (!getters.hasAchievement || !state.achievement.data.reward.linkGame) return null;

      return state.achievement.data.reward.linkGame;
    },
    isAchievementFreeSpinGame(state: State, getters: any) {
      if (!getters.hasAchievement || getters.isAchievementBG || getters.isAchievementFS) return false;

      return getters.getReward.roundsLeft !== null && getters.isGameProperly;
    },
    getAchievementGameNamesList(state: State, getters: any) {
      if (!getters.hasAchievement) return '';

      return state.achievement.data.games.map(data => data.name).join(', ');
    }
  },
  mutations: {
    setAchievementData(state: State, data: IAchievement) {
      if (!data) return;

      state.achievement.data = JSON.parse(JSON.stringify(data));

      const achievementData = state.achievement.data;
      const {
        reward: { wins, linkGame },
        progress
      } = achievementData;
      const currencyDecimals = state.achievement.data.currencyDecimals;
      const currencyCode = state.achievement.data.currencyCode;

      if (linkGame) {
        state.achievement.data.reward.linkGame = linkGame;
      }

      if (!progress?.rounds) {
        const type = progress.bets ? 'bets' : 'wins';
        fixCentProgress(type);
      }

      if (wins) {
        // const cent = Number(Number(wins).toFixed(2));
        const cent = Number(wins);
        achievementData.reward.wins = Utils.centsToMoneyStr(cent, currencyDecimals, currencyCode);
      }

      promoApp.eventEmitter.emit(ACTION.SETTINGS_CORRECT_PROMO);

      function fixCentProgress(type: string) {
        //@ts-ignore
        // const total = progress[type].total.toFixed(2);
        const total = progress[type].total;
        //@ts-ignore
        // const curr = progress[type].current.toFixed(2);
        const curr = progress[type].current;
        //@ts-ignore
        achievementData.progress[type].total = Utils.centsToMoneyStr(total, currencyDecimals, currencyCode);
        //@ts-ignore
        achievementData.progress[type].current = Utils.centsToMoneyStr(curr, currencyDecimals, currencyCode);
      }
    }
  },
  actions: {
    SET_ACHIEVEMENT_DATA({ commit }: ActionContext<any, any>, data: IAchievement) {
      commit('setAchievementData', data);
    },
    CLEAR_ACHIEVEMENT({ commit }: ActionContext<any, any>) {
      if (!store.getters.hasAchievement) return;
      commit('setAchievementData', Achievements);
      commit('settingsCorrectPromo');
    }
  }
};
